import { setAssetFinanceFinanceProposalAmortizationSchedules } from '__core/shared/util/salestrekker';
import template from './assetFinanceProposalAmortizationSchedule.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $timeout,
      $mdUtil,
      $mdDialog,
      eventService,
      helperService,
      dateTimeService,
      assetFinanceService,
      pdfService,
      financesService,
      PaymentFrequency,
      AssetFinanceProposalAmortizationSchedule
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.organizationCountry = '';
      ctrl.destroyWatch = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.destroyWatch = eventService.onAssetFinanceProposalAmortizationScheduleChange(
          (params) => {
            $mdDialog
              .show({
                targetEvent: params.event,
                locals: {
                  contacts: params?.contacts || [],
                  financeProposal: params?.financeProposal || {},
                  ticket: params?.ticket || {},
                  ticketDate: params?.ticketDate || 0,
                  isCommercial: params?.isCommercial || false,
                  isQuickTool: params?.isQuickTool || false
                },
                multiple: true,
                template,
                controllerAs: '$ctrl',
                controller(
                  contacts,
                  financeProposal,
                  ticket,
                  ticketDate,
                  isCommercial,
                  isQuickTool
                ) {
                  const self = this;
                  self.currentCurrency = $rootScope.CurrentCurrency();
                  self.currentLocale = $rootScope.CurrentLocale();
                  self.currentTimeZone = $rootScope.CurrentTimeZone();
                  self.contacts = contacts;
                  self.financeProposal = financeProposal;
                  self.ticketDate = ticketDate;
                  self.ticket = ticket;
                  self.isCommercial = isCommercial;
                  self.isQuickTool = isQuickTool;
                  self.isProcessing = false;
                  self.isPreparing = false;
                  self.clients = [];
                  if (self.ticket && !_.isEmpty(self.ticket?.ticketClientTypes)) {
                    self.idApplicants = _.map(
                      _.filter(
                        self.ticket.ticketClientTypes,
                        (t) => t.idLabel === '018a40bf-027a-4a08-9910-a0cbb058ddab'
                      ),
                      'idContact'
                    );
                    self.clients = _.filter(
                      self.contacts,
                      (c) => self.idApplicants.indexOf(c.id) > -1
                    );
                  } else {
                    self.clients = self.contacts?.length ? self.contacts : [];
                  }
                  self.terms = helperService.getAvailableTermInMonths({
                    isRegular: true
                  });
                  self.paymentFrequencies = assetFinanceService.getAvailablePaymentFrequencies(
                    self.isCommercial
                  );
                  self.hasError =
                    !self.financeProposal?.netAmountFinanced ||
                    !self.financeProposal?.term ||
                    !self.financeProposal?.interestRate ||
                    !self.financeProposal?.estimatedBorrowerRate;
                  self.ballonSchedule = AssetFinanceProposalAmortizationSchedule.Blank();

                  self.getTerm = () =>
                    _.find(self.terms, (t) => t.value === self.financeProposal?.term);

                  self.getBallonPaymentDate = () =>
                    dateTimeService.getFormattedDate(self.ballonSchedule?.paymentDate || 0);

                  self.getPaymentDate = (paymentDate) =>
                    dateTimeService.getFormattedDate(paymentDate || 0);

                  self.changeRepayment = $mdUtil.debounce((idx) => {
                    self.isProcessing = true;
                    if (idx !== undefined && idx > -1) {
                      self.financeProposal.amortizationSchedules[idx].isRepaymentEdited = true;
                    }
                    financesService
                      .assetFinanceFinanceProposalamortizationSchedules({
                        idTicket: self.ticket?.id || '',
                        financeProposalAmortizationScheduleParams: {
                          netAmountFinanced: self.financeProposal?.netAmountFinanced || 0,
                          interestRate: self.financeProposal?.interestRate || 0,
                          term: self.financeProposal?.term || 0,
                          paymentFrequency: self.financeProposal?.paymentFrequency,
                          payments: self.financeProposal?.payments || false,
                          balloonValue: self.financeProposal?.balloonValue || 0,
                          estimatedBorrowerRate:
                            self.financeProposal?.estimatedBorrowerRate || 0,
                          estimatedRepayment: self.financeProposal?.estimatedRepayment || 0,
                          settlementDate: self.ticketDate || 0,
                          amortisationSchedules:
                            self.financeProposal?.amortizationSchedules || []
                        },
                        isQuote: false
                      })
                      .then((res) => {
                        if (res?.status) {
                          self.financeProposal.amortizationSchedules =
                            res?.financeProposalAmortizationSchedule?.amortisationSchedules ||
                            [];
                          self.balloonSchedule =
                            res?.financeProposalAmortizationSchedule?.balloonSchedule || {};
                        }
                        self.isProcessing = false;
                      });
                  }, 1500);

                  self.toggleStructurePayments = () => {
                    if (!self.financeProposal?.isStructured) {
                      self.resetRepayments();
                    } else {
                      ctrl.onFinished({ financeProposal: self.financeProposal });
                    }
                  };

                  self.resetRepayments = () => {
                    self.financeProposal.isStructured = false;
                    self.financeProposal.amortizationSchedules = [];
                    self.financeProposal = setAssetFinanceFinanceProposalAmortizationSchedules(
                      self.financeProposal || {},
                      self.ticketDate || parseInt(moment.utc() || 0, 10),
                      self.currentTimeZone,
                      self.currentLocale
                    );
                    ctrl.onFinished({ financeProposal: self.financeProposal });
                  };

                  self.createPdf = (isView) => {
                    if (isView) {
                      self.isViewPreparing = true;
                    } else {
                      self.isDownloadPreparing = true;
                    }
                    pdfService
                      .createPdf({
                        contacts: self.clients,
                        financeProposal: self.financeProposal,
                        ticket: self.ticket,
                        settlementDate: self.ticketDate,
                        pdfType: helperService.getAvailablePdfTypes()[7],
                        isCommercial: self.isCommercial,
                        isQuickTool: self.isQuickTool,
                        isView
                      })
                      .then(() => {
                        if (isView) {
                          self.isViewPreparing = false;
                        } else {
                          self.isDownloadPreparing = false;
                        }
                      });
                  };

                  self.cancel = () => {
                    ctrl.onFinished({ financeProposal: self.financeProposal });
                    $mdDialog.cancel();
                  };
                }
              })
              .then(() => {});
          }
        );
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
